class CartControls {
  constructor() {
    if (CartControls.instance) {
      return CartControls.instance;
    }

    CartControls.instance = this;

    this.providerId = "66f84fa37bbcb7bf2ec9a133"; //add providerId from DB
    this.domain = "https://api.unicheck.app/api/v1/delivery/novaPost";

    this.deliveryCity = "";
    this.currentInputId = null;

    this.defaultLanguage = "en";
    this.language = window?.Shopify?.locale || this.defaultLanguage;
    this.defineTranslations();

    this.isHovered = false;
    this.isOriginalText = true;

    this.init();
  }

  addControlButtons() {
    const inited = this.init();
    if (!inited) {
      console.log("Failed to init NP");
      return;
    }

    this.removeEventHandlers();
    this.bindEventHandlers();
  }

  bindEventHandlers() {
    this.changeHandlerBound = this.changeHandler.bind(this);
    this.toggleOverlayBound = this.toggleOverlay.bind(this);
    this.controlButtonClickHandlerBound =
      this.controlButtonClickHandler.bind(this);
    this.inputHandlerBound = this.inputHandler.bind(this);
    this.documentClickHandlerBound = this.documentClickHandler.bind(this);
    this.mouseoverHandlerBound = this.mouseoverHandler.bind(this);
    this.mouseoutHandlerBound = this.mouseoutHandler.bind(this);
    this.submitHandlerBound = this.submitHandler.bind(this);

    this.deliveryTypeRadios.forEach((radio) => {
      radio.addEventListener("change", this.changeHandlerBound);
    });

    this.overlayCloseBtn.addEventListener("click", this.toggleOverlayBound);

    this.controlButtons?.addEventListener(
      "click",
      this.controlButtonClickHandlerBound
    );

    this.inputs.forEach((input) => {
      input.addEventListener("input", this.inputHandlerBound);
    });

    document.addEventListener("click", this.documentClickHandlerBound);

    this.submitButton?.addEventListener(
      "mouseover",
      this.mouseoverHandlerBound
    );
    this.submitButton?.addEventListener("mouseout", this.mouseoutHandlerBound);

    this.submitButton?.addEventListener("click", this.submitHandlerBound);
  }

  removeEventHandlers() {
    this.deliveryTypeRadios.forEach((radio) => {
      radio.removeEventListener("change", this.changeHandlerBound);
    });

    this.overlayCloseBtn.removeEventListener("click", this.toggleOverlayBound);

    this.controlButtons?.removeEventListener(
      "click",
      this.controlButtonClickHandlerBound
    );

    this.inputs.forEach((input) => {
      input.removeEventListener("input", this.inputHandlerBound);
    });

    document.removeEventListener("click", this.documentClickHandlerBound);

    this.submitButton?.removeEventListener(
      "mouseover",
      this.mouseoverHandlerBound
    );
    this.submitButton?.removeEventListener(
      "mouseout",
      this.mouseoutHandlerBound
    );

    this.submitButton?.removeEventListener("click", this.submitHandlerBound);
  }

  init() {
    this.cart = document.querySelector("cart-drawer.drawer");
    console.log(this.cart)

    this.cartFooter = this.cart.querySelector(".drawer__footer");

    if (!this.cartFooter) {
      return false;
    }

    this.cart.style["overflow-y"] = "hidden";

    this.controlButtons = this.cart.querySelector(".cart-controls__buttons");
    this.overlay = this.cart.querySelector(".cart-controls__overlay");
    this.overlayCloseBtn = this.cart.querySelector(
      ".controls-overlay__close-button"
    );
    this.suggestionsLists = this.cart.querySelectorAll(
      ".overlay-form__suggestions"
    );
    this.deliveryTypeRadios = this.cart.querySelectorAll(
      ".overlay-form__radio-input"
    );
    this.inputs = this.cart.querySelectorAll(".overlay-form__input");

    this.submitButton = this.cartFooter.querySelector('button[type="submit"]');
    this.originalSubmitButtonText = this.submitButton.innerHTML;
    this.submitButton.style.minHeight = this.submitButton.offsetHeight + "px";

    const { deliveryType } = this.getDeliveryInfo();
    this.checkDeliveryType(deliveryType);

    return true;
  }

  toggleOverlay() {
    this.overlay.classList.toggle("active");

    if (this.overlay.classList.contains("active")) {
      this.submitButton.style.position = "relative";
      this.submitButton.style.zIndex = "100";
      this.submitButton.form.style.zIndex = "100";
    } else {
      setTimeout(() => {
        this.submitButton.style.zIndex = "1";
        this.submitButton.form.style.zIndex = "1";
      }, 200);
    }
  }

  changeHandler(event) {
    const deliveryType = event.target.value;

    this.checkDeliveryType(deliveryType);
  }

  checkDeliveryType(deliveryType) {
    if (deliveryType === "international-delivery") {
      this.inputs.forEach((input) => {
        if (input.name === "name" || input.name === "phone") return;
        input.disabled = true;
      });
    } else {
      this.inputs.forEach((input) => {
        input.disabled = false;
      });
    }
  }

  controlButtonClickHandler(event) {
    if (event.target.closest(".control-button")) {
      this.toggleOverlay();
    }
  }

  inputHandler(event) {
    const value = event.target.value.trim();
    const inputId = event.target.id;

    if (value) {
      if (inputId === "settlement") {
        fetch(`${this.domain}/searchSettlements`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            providerId: this.providerId,
            cityName: value,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            // Display suggestions (elastic search)
            this.displaySuggestions(inputId, data?.settlements);
          })
          .catch((error) => {
            console.error("Error:", error?.message || error);
          });
      } else if (inputId === "warehouse") {
        fetch(`${this.domain}/getWarehouses`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            findByString: value,
            providerId: this.providerId,
            cityRef: this.deliveryCity,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            // Display suggestions (elastic search)
            this.displaySuggestions(inputId, data?.warehouses);
          })
          .catch((error) => {
            console.error("Error:", error?.message || error);
          });
      }
    } else {
      // Clear suggestions (elastic search) if input is empty
      if (inputId === "name" || inputId === "phone") {
        return;
      }

      this.clearSuggestions(inputId);
    }
  }

  displaySuggestions(inputId, data) {
    this.currentInputId = inputId;

    const suggestionsList = this.cart.querySelector(`#suggestions-${inputId}`);
    suggestionsList.innerHTML = "";

    const isSettlement = inputId === "settlement";

    data?.forEach((item) => {
      const li = document.createElement("li");
      li.textContent = isSettlement ? item.Present : item.Description;

      const suggestionClickHandler = (event) => {
        this.cart.querySelector(`#${inputId}`).value = isSettlement
          ? item.Present
          : item.Description;
        this.clearSuggestions(inputId);

        if (isSettlement) {
          this.deliveryCity = item.DeliveryCity;
        }

        event.stopPropagation();
      };

      li.addEventListener("click", suggestionClickHandler);

      suggestionsList.appendChild(li);
    });
    suggestionsList.style.display = "block";
  }

  clearSuggestions(inputId) {
    const suggestionsList = this.cart.querySelector(`#suggestions-${inputId}`);
    suggestionsList.innerHTML = "";
    suggestionsList.style.display = "none";
  }

  documentClickHandler(event) {
    const isInput = event.target.classList.contains("overlay-form__input");
    const isSuggestion = event.target.classList.contains(
      "overlay-form__suggestions"
    );
    const isCurrentInput = event.target.id === this.currentInputId;

    if ((!isInput && !isSuggestion) || !isCurrentInput) {
      this.suggestionsLists?.forEach((list) => {
        list.style.display = "none";
      });
    }
  }

  getDeliveryInfo() {
    const deliveryType = this.cart.querySelector(
      'input[name="delivery-type"]:checked'
    ).value;
    const name = this.cart.querySelector("#name").value;
    const phone = this.cart.querySelector("#phone").value;
    const settlement = this.cart.querySelector("#settlement").value;
    const warehouse = this.cart.querySelector("#warehouse").value;

    return {
      deliveryType,
      name,
      phone,
      settlement,
      warehouse,
    };
  }

  mouseoverHandler() {
    if (!this.isHovered) {
      this.changeSubmitButtonText(this.translations.chooseDeliveryMethod);
      this.isHovered = true;
      this.isOriginalText = false;
    }
  }

  mouseoutHandler() {
    if (!this.isOriginalText) {
      this.changeSubmitButtonText(this.originalSubmitButtonText);
      this.isHovered = false;
      this.isOriginalText = true;
    }
  }

  changeSubmitButtonText(text) {
    if (this.submitButton.innerHTML !== text) {
      const { deliveryType, name, phone, settlement, warehouse } =
        this.getDeliveryInfo();

      const animate = () => {
        this.submitButton.classList.add("change-text-animation");

        setTimeout(() => {
          this.submitButton.innerHTML = text;
        }, 125); // Animation duration (half of the CSS transition duration)

        setTimeout(() => {
          this.submitButton.classList.remove("change-text-animation");
        }, 250); // Animation duration (CSS transition duration)
      };

      if (!name || !phone) {
        animate();
        return;
      }

      if (deliveryType === "warehouse") {
        if (!settlement || !warehouse) {
          animate();
        }
      }
    }
  }

  async submitHandler(event) {
    event.preventDefault();

    const { deliveryType, name, phone, settlement, warehouse } =
      this.getDeliveryInfo();
    const isWarehouse = deliveryType === "warehouse";

    // Open overlay if name or phone is not selected
    if (!name || !phone) {
      if (!this.overlay.classList.contains("active")) {
        this.toggleOverlay();
      }
      return;
    }

    // Open overlay if warehouse delivery is selected but settlement or warehouse is not selected
    if (isWarehouse) {
      if (!settlement || !warehouse) {
        if (!this.overlay.classList.contains("active")) {
          this.toggleOverlay();
        }
        return;
      }
    }

    // Cart attributes
    const names = name?.split(" ");
    const firstName = names?.shift();
    const lastName = names?.join(" ");

    const attributes = isWarehouse
      ? {
          _provider: "Нова пошта",
          _delivery_method: "Відділення / Поштомат",
          _delivery_first_name: firstName,
          _delivery_last_name: lastName,
          _delivery_phone: phone,
          _delivery_city: settlement,
          _delivery_warehouse: warehouse,
          _delivery_warehouse_zip: "11111",
        }
      : {
          _provider: "",
          _delivery_method: "Міжнародна доставка",
          _delivery_first_name: firstName,
          _delivery_last_name: lastName,
          _delivery_phone: phone,
          _delivery_city: "",
          _delivery_warehouse: "",
          _delivery_warehouse_zip: "",
        };

    try {
      // Update cart attributes
      await fetch("/cart/update.js", {
        method: "POST",
        mode: "cors",
        credentials: "include",
        cache: "no-cache",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          attributes,
        }),
      });

      let countryCode;

      try {
        const geoResponse = await fetch("https://ipinfo.io/json");
        if (geoResponse.ok) {
          const geo = await geoResponse.json();
          countryCode = geo?.country;
        }
      } catch (err) {
        console.warn("geo IP fetch failed or blocked");
      }

      // Add delivery info to cart note
      const address = isWarehouse
        ? {
            countryCode: "UA",
            country: "Ukraine",
            address1: warehouse,
            zip: "11111",
            city: settlement,
            first_name: firstName,
            last_name: lastName,
            phone: phone,
          }
        : {
            ...(countryCode
              ? {
                  countryCode: countryCode,
                  country: this.defineCountry(countryCode),
                }
              : {}),
            address1: "",
            zip: "",
            city: "",
            first_name: firstName,
            last_name: lastName,
            phone: phone,
          };

      const response = await fetch("/cart.json");
      const data = await response.json();

      const pairs = [],
        path = data.items
          .map((item) => `${item.variant_id}:${item.quantity}`)
          .join(",");
      for (const key in attributes) {
        if (!attributes[key]) continue;
        const pair = `attributes[${key}]=${attributes[key]}`;
        pairs.push(pair);
      }
      for (const key in address) {
        const pair = `checkout[shipping_address][${key}]=${address[key]}`;
        pairs.push(pair);
      }

      // Redirect to checkout
      let params, url;
      const isDefaultLanguage = this.defaultLanguage === this.language;
      data.note && data.note != null
        ? ((params = pairs.join("&") + `&note=${data.note}`),
          (url = isDefaultLanguage
            ? `/cart/${path}?${params}`
            : `/${this.language}/cart/${path}?${params}`))
        : ((params = pairs.join("&")),
          (url = isDefaultLanguage
            ? `/cart/${path}?${params}`
            : `/${this.language}/cart/${path}?${params}`)),
        (window.location.href = url);
    } catch (error) {
      console.error("Error:", error);
    }
  }

  defineTranslations() {
    console.log(this.language)
    if (this.language === "uk") {
      this.translations = {
        shipping: "Оберіть спосіб доставки",
        chooseDeliveryMethod: "Оберіть спосіб доставки",
        options: {
          warehouse: "Доставка Новою Поштою",
          internationalDelivery: "Міжнародна доставка",
        },
        inputPlaceholders: {
          name: "Ім'я та прізвище",
          phone: "Номер телефону",
          settlement: "Оберіть населений пункт",
          warehouse: "Оберіть відділення або поштомат",
        },
      };
    } else if (this.language === "de") {
      this.translations = {
        shipping: "Versandart auswählen",
        chooseDeliveryMethod: "Versandart auswählen",
        options: {
            warehouse: "NovaPoshta",
            internationalDelivery: "Internationaler Versand"
        },
        inputPlaceholders: {
            name: "Vor- und Nachname",
            phone: "Telefonnummer",
            settlement: "Zahlungsart auswählen",
            warehouse: "Filiale/Postamt auswählen"
        },
      };
    } else {
      // en by default
      this.translations = {
        shipping: "Choose a delivery method",
        chooseDeliveryMethod: "Choose a delivery method",
        options: {
          warehouse: "NovaPoshta",
          internationalDelivery: "International delivery",
        },
        inputPlaceholders: {
          name: "First and Last names",
          phone: "Phone number",
          settlement: "Select a settlement",
          warehouse: "Select branch / post office",
        },
      };
    }
  }

  defineCountry(countryCode) {
    const countries = {
      AF: "Afghanistan",
      AX: "Aland Islands",
      AL: "Albania",
      DZ: "Algeria",
      AS: "American Samoa",
      AD: "Andorra",
      AO: "Angola",
      AI: "Anguilla",
      AQ: "Antarctica",
      AG: "Antigua And Barbuda",
      AR: "Argentina",
      AM: "Armenia",
      AW: "Aruba",
      AU: "Australia",
      AT: "Austria",
      AZ: "Azerbaijan",
      BS: "Bahamas",
      BH: "Bahrain",
      BD: "Bangladesh",
      BB: "Barbados",
      BY: "Belarus",
      BE: "Belgium",
      BZ: "Belize",
      BJ: "Benin",
      BM: "Bermuda",
      BT: "Bhutan",
      BO: "Bolivia",
      BA: "Bosnia And Herzegovina",
      BW: "Botswana",
      BV: "Bouvet Island",
      BR: "Brazil",
      IO: "British Indian Ocean Territory",
      BN: "Brunei Darussalam",
      BG: "Bulgaria",
      BF: "Burkina Faso",
      BI: "Burundi",
      KH: "Cambodia",
      CM: "Cameroon",
      CA: "Canada",
      CV: "Cape Verde",
      KY: "Cayman Islands",
      CF: "Central African Republic",
      TD: "Chad",
      CL: "Chile",
      CN: "China",
      CX: "Christmas Island",
      CC: "Cocos (Keeling) Islands",
      CO: "Colombia",
      KM: "Comoros",
      CG: "Congo",
      CD: "Congo, Democratic Republic",
      CK: "Cook Islands",
      CR: "Costa Rica",
      CI: "Cote D'Ivoire",
      HR: "Croatia",
      CU: "Cuba",
      CY: "Cyprus",
      CZ: "Czech Republic",
      DK: "Denmark",
      DJ: "Djibouti",
      DM: "Dominica",
      DO: "Dominican Republic",
      EC: "Ecuador",
      EG: "Egypt",
      SV: "El Salvador",
      GQ: "Equatorial Guinea",
      ER: "Eritrea",
      EE: "Estonia",
      ET: "Ethiopia",
      FK: "Falkland Islands (Malvinas)",
      FO: "Faroe Islands",
      FJ: "Fiji",
      FI: "Finland",
      FR: "France",
      GF: "French Guiana",
      PF: "French Polynesia",
      TF: "French Southern Territories",
      GA: "Gabon",
      GM: "Gambia",
      GE: "Georgia",
      DE: "Germany",
      GH: "Ghana",
      GI: "Gibraltar",
      GR: "Greece",
      GL: "Greenland",
      GD: "Grenada",
      GP: "Guadeloupe",
      GU: "Guam",
      GT: "Guatemala",
      GG: "Guernsey",
      GN: "Guinea",
      GW: "Guinea-Bissau",
      GY: "Guyana",
      HT: "Haiti",
      HM: "Heard Island & Mcdonald Islands",
      VA: "Holy See (Vatican City State)",
      HN: "Honduras",
      HK: "Hong Kong",
      HU: "Hungary",
      IS: "Iceland",
      IN: "India",
      ID: "Indonesia",
      IR: "Iran, Islamic Republic Of",
      IQ: "Iraq",
      IE: "Ireland",
      IM: "Isle Of Man",
      IL: "Israel",
      IT: "Italy",
      JM: "Jamaica",
      JP: "Japan",
      JE: "Jersey",
      JO: "Jordan",
      KZ: "Kazakhstan",
      KE: "Kenya",
      KI: "Kiribati",
      KR: "Korea",
      KW: "Kuwait",
      KG: "Kyrgyzstan",
      LA: "Lao People's Democratic Republic",
      LV: "Latvia",
      LB: "Lebanon",
      LS: "Lesotho",
      LR: "Liberia",
      LY: "Libyan Arab Jamahiriya",
      LI: "Liechtenstein",
      LT: "Lithuania",
      LU: "Luxembourg",
      MO: "Macao",
      MK: "Macedonia",
      MG: "Madagascar",
      MW: "Malawi",
      MY: "Malaysia",
      MV: "Maldives",
      ML: "Mali",
      MT: "Malta",
      MH: "Marshall Islands",
      MQ: "Martinique",
      MR: "Mauritania",
      MU: "Mauritius",
      YT: "Mayotte",
      MX: "Mexico",
      FM: "Micronesia, Federated States Of",
      MD: "Moldova",
      MC: "Monaco",
      MN: "Mongolia",
      ME: "Montenegro",
      MS: "Montserrat",
      MA: "Morocco",
      MZ: "Mozambique",
      MM: "Myanmar",
      NA: "Namibia",
      NR: "Nauru",
      NP: "Nepal",
      NL: "Netherlands",
      AN: "Netherlands Antilles",
      NC: "New Caledonia",
      NZ: "New Zealand",
      NI: "Nicaragua",
      NE: "Niger",
      NG: "Nigeria",
      NU: "Niue",
      NF: "Norfolk Island",
      MP: "Northern Mariana Islands",
      NO: "Norway",
      OM: "Oman",
      PK: "Pakistan",
      PW: "Palau",
      PS: "Palestinian Territory, Occupied",
      PA: "Panama",
      PG: "Papua New Guinea",
      PY: "Paraguay",
      PE: "Peru",
      PH: "Philippines",
      PN: "Pitcairn",
      PL: "Poland",
      PT: "Portugal",
      PR: "Puerto Rico",
      QA: "Qatar",
      RE: "Reunion",
      RO: "Romania",
      RU: "Russian Federation",
      RW: "Rwanda",
      BL: "Saint Barthelemy",
      SH: "Saint Helena",
      KN: "Saint Kitts And Nevis",
      LC: "Saint Lucia",
      MF: "Saint Martin",
      PM: "Saint Pierre And Miquelon",
      VC: "Saint Vincent And Grenadines",
      WS: "Samoa",
      SM: "San Marino",
      ST: "Sao Tome And Principe",
      SA: "Saudi Arabia",
      SN: "Senegal",
      RS: "Serbia",
      SC: "Seychelles",
      SL: "Sierra Leone",
      SG: "Singapore",
      SK: "Slovakia",
      SI: "Slovenia",
      SB: "Solomon Islands",
      SO: "Somalia",
      ZA: "South Africa",
      GS: "South Georgia And Sandwich Isl.",
      ES: "Spain",
      LK: "Sri Lanka",
      SD: "Sudan",
      SR: "Suriname",
      SJ: "Svalbard And Jan Mayen",
      SZ: "Swaziland",
      SE: "Sweden",
      CH: "Switzerland",
      SY: "Syrian Arab Republic",
      TW: "Taiwan",
      TJ: "Tajikistan",
      TZ: "Tanzania",
      TH: "Thailand",
      TL: "Timor-Leste",
      TG: "Togo",
      TK: "Tokelau",
      TO: "Tonga",
      TT: "Trinidad And Tobago",
      TN: "Tunisia",
      TR: "Turkey",
      TM: "Turkmenistan",
      TC: "Turks And Caicos Islands",
      TV: "Tuvalu",
      UG: "Uganda",
      UA: "Ukraine",
      AE: "United Arab Emirates",
      GB: "United Kingdom",
      US: "United States",
      UM: "United States Outlying Islands",
      UY: "Uruguay",
      UZ: "Uzbekistan",
      VU: "Vanuatu",
      VE: "Venezuela",
      VN: "Viet Nam",
      VG: "Virgin Islands, British",
      VI: "Virgin Islands, U.S.",
      WF: "Wallis And Futuna",
      EH: "Western Sahara",
      YE: "Yemen",
      ZM: "Zambia",
      ZW: "Zimbabwe",
    };

    return countries[countryCode];
  }
}

class NovaPost extends HTMLElement {
  connectedCallback() {
    const cartControls = new CartControls();
    cartControls.addControlButtons();
  }
}

customElements.define('nova-post', NovaPost);